import { useEffect } from 'react';
import { message } from 'antd';
import { checkCache } from '@/service/user-service';

const CheckCache = () => {
  const getCheckCache = async () => {
    if (import.meta.env.VITE_APP_PRIVATE === 'aweita') {
      const response = await checkCache();
      if (response.success) {
        if (response.data) {
          window.location.href = '/cms/redirect';
        }
      } else {
        message.error(response.message);
      }
    }
  };

  useEffect(() => {
    getCheckCache();
  }, []);
  return null;
};

export default CheckCache;
